<div class="contact-content">
    <div class="contact-form">
        <h3>{{"shoppingCart.personalDatasUpperCase" | translate}}</h3>
        <form [formGroup]="contactForm!" novalidate *ngIf="!personalData!.isCompany">
            <label>{{"contact.email" | translate}}</label>
            <input
                [(ngModel)]="personalData!.email!"
                formControlName="email"
                placeholder="{{ 'contact.email' | translate }}*"
                id="email"
                class="form-control"
                type="email"
                required
                [ngStyle]="contactForm!.controls['email'].invalid && (contactForm!.controls['email'].dirty || contactForm!.controls['email'].touched) && contactForm!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactForm!.controls['email'].invalid && (contactForm!.controls['email'].dirty || contactForm!.controls['email'].touched)"
                class="alert-email"
            >
                <div *ngIf="contactForm!.controls['email'].errors?.['required']">
                    <span>{{ 'contact.emailRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactForm!.get('email')!.hasError('pattern')">
                    Helyes email formátum: "info@gmail.com".
                </span>
            </div>

            <br />
            <div class="name">
                <div class="last-name">
                    <label>{{"login.lastName" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.lastName!"
                        placeholder="{{ 'contact.lastName' | translate }}*"
                        formControlName="lastName"
                        id="lastName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactForm!.controls['lastName'].invalid && (contactForm!.controls['lastName'].dirty || contactForm!.controls['lastName'].touched) && contactForm!.controls['lastName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['lastName'].invalid && (contactForm!.controls['lastName'].dirty || contactForm!.controls['lastName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactForm!.controls['lastName'].errors?.['required']">
                            <span>{{ 'contact.lastNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
                <div class="first-name">
                    <label>{{"login.firstName" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.firstName!"
                        placeholder="{{ 'contact.firstName' | translate }}*"
                        formControlName="firstName"
                        id="firstName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactForm!.controls['firstName'].invalid && (contactForm!.controls['firstName'].dirty || contactForm!.controls['firstName'].touched) && contactForm!.controls['firstName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['firstName'].invalid && (contactForm!.controls['firstName'].dirty || contactForm!.controls['firstName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactForm!.controls['firstName'].errors?.['required']">
                            <span>{{ 'contact.firstNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
            </div>
            <label>{{"login.phoneNumber" | translate}}</label>
            <div class="input-phone">
                <div class="phone-label">
                    <label>{{hungarianPhonePrefix}}</label>
                </div>
                <div class="phone-number">
                    <input
                        [(ngModel)]="personalData!.phoneNumber"
                        formControlName="phoneNumber"
                        placeholder="{{ 'contact.phoneNumber' | translate }}*"
                        id="phoneNumber"
                        class="form-control"
                        type="phoneNumber"
                        required
                        [ngStyle]="contactForm!.controls['phoneNumber'].invalid && (contactForm!.controls['phoneNumber'].dirty || contactForm!.controls['phoneNumber'].touched) && contactForm!.controls['phoneNumber'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                    /><br />
                </div>
            </div>

            <div
                *ngIf="contactForm!.controls['phoneNumber'].invalid && (contactForm!.controls['phoneNumber'].dirty || contactForm!.controls['phoneNumber'].touched)"
                class="alert-phoneNumber"
            >
                <div *ngIf="contactForm!.controls['phoneNumber'].errors?.['required']">
                    <span>{{ 'contact.phoneNumberRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactForm!.get('phoneNumber')!.hasError('pattern')">
                    Rossz telefonszám formátum!
                </span>
            </div>

            <br />
            <div class="zip-settlement-container">
                <div class="zipcode">
                    <label>{{"login.zipcode" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.zipCode"
                        placeholder="{{ 'contact.zipcode' | translate }}*"
                        type="text"
                        formControlName="zipCode"
                        id="zipCode"
                        class="form-control"
                        required
                        [ngStyle]="contactForm!.controls['zipCode'].invalid && (contactForm!.controls['zipCode'].dirty || contactForm!.controls['zipCode'].touched) && contactForm!.controls['zipCode'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['zipCode'].invalid && (contactForm!.controls['zipCode'].dirty || contactForm!.controls['zipCode'].touched)"
                        class="alert-zipCode"
                    >
                        <div *ngIf="contactForm!.controls['zipCode'].errors?.['required']">
                            <span>{{"contact.zipRequired" | translate }}</span>
                        </div>
                        <span class="text-danger" *ngIf="contactForm!.get('zipCode')!.hasError('pattern')">
                            Helyes irányítószám: "1234" - négy darab számjegy.
                        </span>
                    </div>
                    <br />
                </div>
                <div class="settlement">
                    <label>{{"login.settlement" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.settlement"
                        placeholder="{{ 'contact.settlement' | translate }}*"
                        type="text"
                        formControlName="settlement"
                        id="settlement"
                        class="form-control"
                        required
                        [ngStyle]="contactForm!.controls['settlement'].invalid && (contactForm!.controls['settlement'].dirty || contactForm!.controls['settlement'].touched) && contactForm!.controls['settlement'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactForm!.controls['settlement'].invalid && (contactForm!.controls['settlement'].dirty || contactForm!.controls['settlement'].touched)"
                        class="alert-settlement"
                    >
                        <div *ngIf="contactForm!.controls['settlement'].errors?.['required']">
                            <span>{{ 'contact.cityRequired' | translate }}</span>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <label>{{"login.address" | translate}}</label>
            <input
                [(ngModel)]="personalData!.address"
                placeholder="{{ 'contact.address' | translate }}*"
                type="text"
                formControlName="address"
                id="address"
                class="form-control"
                required
                [ngStyle]="contactForm!.controls['address'].invalid && (contactForm!.controls['address'].dirty || contactForm!.controls['address'].touched) && contactForm!.controls['address'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactForm!.controls['address'].invalid && (contactForm!.controls['address'].dirty || contactForm!.controls['address'].touched)"
                class="alert-address"
            >
                <div *ngIf="contactForm!.controls['address'].errors?.['required']">
                    <span>{{ 'contact.addressRequired' | translate }}</span>
                </div>
            </div>
            <br />
        </form>

        <form [formGroup]="contactFormCompany!" novalidate *ngIf="personalData!.isCompany">
            <label>{{"login.companyName" | translate}}</label>
            <input
                [(ngModel)]="personalData!.companyName"
                formControlName="companyName"
                placeholder="{{ 'contact.companyName' | translate }}*"
                type="text"
                id="companyName"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['companyName'].invalid && (contactFormCompany!.controls['companyName'].dirty || contactFormCompany!.controls['companyName'].touched) && contactFormCompany!.controls['companyName'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['companyName'].invalid && (contactFormCompany!.controls['companyName'].dirty || contactFormCompany!.controls['companyName'].touched)"
                class="alert-compName"
            >
                <div *ngIf="contactFormCompany!.controls['companyName'].errors?.['required']">
                    <span>{{ 'contact.companyNameRequired' | translate }}</span>
                </div>
            </div>
            <br />
            <div class="name">
                <div class="last-name">
                    <label>{{"login.lastName" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.lastName!"
                        placeholder="{{ 'contact.lastName' | translate }}*"
                        formControlName="lastName"
                        id="lastName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactFormCompany!!.controls['lastName'].invalid && (contactFormCompany!!.controls['lastName'].dirty || contactFormCompany!!.controls['lastName'].touched) && contactFormCompany!!.controls['lastName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!!.controls['lastName'].invalid && (contactFormCompany!!.controls['lastName'].dirty || contactFormCompany!!.controls['lastName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactFormCompany!!.controls['lastName'].errors?.['required']">
                            <span>{{ 'contact.lastNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
                <div class="first-name">
                    <label>{{"login.firstName" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.firstName!"
                        placeholder="{{ 'contact.firstName' | translate }}*"
                        formControlName="firstName"
                        id="firstName"
                        class="form-control"
                        type="text"
                        required
                        [ngStyle]="contactFormCompany!!.controls['firstName'].invalid && (contactFormCompany!!.controls['firstName'].dirty || contactFormCompany!!.controls['firstName'].touched) && contactFormCompany!!.controls['firstName'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!!.controls['firstName'].invalid && (contactFormCompany!!.controls['firstName'].dirty || contactFormCompany!!.controls['firstName'].touched)"
                        class="alert-name"
                    >
                        <div *ngIf="contactFormCompany!!.controls['firstName'].errors?.['required']">
                            <span>{{ 'contact.firstNameRequired' | translate }}</span>
                        </div>
                    </div>

                    <br />
                </div>
            </div>
            <label>{{"login.email" | translate}}</label>
            <input
                [(ngModel)]="personalData!.email"
                formControlName="companyEmail"
                placeholder="{{ 'contact.email' | translate }}*"
                type="email"
                id="companyEmail"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['companyEmail'].invalid && (contactFormCompany!.controls['companyEmail'].dirty || contactFormCompany!.controls['companyEmail'].touched) && contactFormCompany!.controls['companyEmail'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['companyEmail'].invalid && (contactFormCompany!.controls['companyEmail'].dirty || contactFormCompany!.controls['companyEmail'].touched)"
                class="alert-companyEmail"
            >
                <div *ngIf="contactFormCompany!.controls['companyEmail'].errors?.['required']">
                    <span>{{ 'contact.emailRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactFormCompany!.get('companyEmail')!.hasError('pattern')">
                    Helyes email formátum: "info@gmail.com".
                </span>
            </div>
            <br />
            <label>{{"login.phoneNumber" | translate}}</label>
            <input
                [(ngModel)]="personalData!.phoneNumber"
                formControlName="phoneNumber"
                placeholder="{{ 'contact.phoneNumber' | translate }}*"
                id="phoneNumber"
                class="form-control"
                type="phoneNumber"
                required
                [ngStyle]="contactFormCompany!.controls['phoneNumber'].invalid && (contactFormCompany!.controls['phoneNumber'].dirty || contactFormCompany!.controls['phoneNumber'].touched) && contactFormCompany!.controls['phoneNumber'].errors?.['required'] && {'border':'1px solid red'}"
                autofocus
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['phoneNumber'].invalid && (contactFormCompany!.controls['phoneNumber'].dirty || contactFormCompany!.controls['phoneNumber'].touched)"
                class="alert-phoneNumber"
            >
                <div *ngIf="contactFormCompany!.controls['phoneNumber'].errors?.['required']">
                    <span>{{ 'contact.phoneNumberRequired' | translate }}</span>
                </div>
                <span class="text-danger" *ngIf="contactFormCompany!.get('phoneNumber')!.hasError('pattern')">
                    Rossz telefonszám formátum!
                </span>
            </div>

            <br />
            <label>{{"login.taxNumber" | translate}}</label>
            <input
                [(ngModel)]="personalData!.taxNumber"
                formControlName="vatNumber"
                placeholder="{{ 'contact.vatNumber' | translate }}*"
                type="text"
                id="vatNumber"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['vatNumber'].invalid && (contactFormCompany!.controls['vatNumber'].dirty || contactFormCompany!.controls['vatNumber'].touched) && contactFormCompany!.controls['vatNumber'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['vatNumber'].invalid && (contactFormCompany!.controls['vatNumber'].dirty || contactFormCompany!.controls['vatNumber'].touched)"
                class="alert-vatNumber"
            >
                <div *ngIf="contactFormCompany!.controls['vatNumber'].errors?.['required']">
                    <span>{{ 'contact.vatRequired' | translate }}</span>
                </div>
            </div>
            <br />
            <div class="zip-settlement-container">
                <div class="zipcode">
                    <label>{{"login.zipcode" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.zipCode"
                        placeholder="{{ 'contact.zipcode' | translate }}*"
                        type="text"
                        formControlName="companyZipCode"
                        id="companyZipCode"
                        class="form-control"
                        required
                        [ngStyle]="contactFormCompany!.controls['companyZipCode'].invalid && (contactFormCompany!.controls['companyZipCode'].dirty || contactFormCompany!.controls['companyZipCode'].touched) && contactFormCompany!.controls['companyZipCode'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!.controls['companyZipCode'].invalid && (contactFormCompany!.controls['companyZipCode'].dirty || contactFormCompany!.controls['companyZipCode'].touched)"
                        class="alert-companyZipCode"
                    >
                        <div *ngIf="contactFormCompany!.controls['companyZipCode'].errors?.['required']">
                            <span>{{"contact.zipRequired" | translate }}</span>
                        </div>
                        <span class="text-danger" *ngIf="contactFormCompany!.get('companyZipCode')!.hasError('pattern')">
                            Helyes irányítószám: "1234" - négy darab számjegy.
                        </span>
                    </div>
                    <br />
                </div>
                <div class="settlement">
                    <label>{{"login.settlement" | translate}}</label>
                    <input
                        [(ngModel)]="personalData!.settlement"
                        placeholder="{{ 'contact.settlement' | translate }}*"
                        type="text"
                        formControlName="companySettlement"
                        id="companySettlement"
                        class="form-control"
                        required
                        [ngStyle]="contactFormCompany!.controls['companySettlement'].invalid && (contactFormCompany!.controls['companySettlement'].dirty || contactFormCompany!.controls['companySettlement'].touched) && contactFormCompany!.controls['companySettlement'].errors?.['required'] && {'border':'1px solid red'}"
                    /><br />

                    <div
                        *ngIf="contactFormCompany!.controls['companySettlement'].invalid && (contactFormCompany!.controls['companySettlement'].dirty || contactFormCompany!.controls['companySettlement'].touched)"
                        class="alert-companySettlement"
                    >
                        <div *ngIf="contactFormCompany!.controls['companySettlement'].errors?.['required']">
                            <span>{{ 'contact.cityRequired' | translate }}</span>
                        </div>
                    </div>
                    <br />
                </div>
            </div>
            <label>{{"login.address" | translate}}</label>
            <input
                [(ngModel)]="personalData!.address"
                placeholder="{{ 'contact.address' | translate }}*"
                type="text"
                formControlName="companyAddress"
                id="companyAddress"
                class="form-control"
                required
                [ngStyle]="contactFormCompany!.controls['companyAddress'].invalid && (contactFormCompany!.controls['companyAddress'].dirty || contactFormCompany!.controls['companyAddress'].touched) && contactFormCompany!.controls['companyAddress'].errors?.['required'] && {'border':'1px solid red'}"
            /><br />

            <div
                *ngIf="contactFormCompany!.controls['companyAddress'].invalid && (contactFormCompany!.controls['companyAddress'].dirty || contactFormCompany!.controls['companyAddress'].touched)"
                class="alert-companyAddress"
            >
                <div *ngIf="contactFormCompany!.controls['companyAddress'].errors?.['required']">
                    <span>{{ 'contact.addressRequired' | translate }}</span>
                </div>
            </div>
            <br />
        </form>
    </div>
    <div *ngIf="personalData?.subscribedForNewsLetter" class="news">
        <input (click)="unsubscribeForNewsLetter()" type="checkbox" checked />
        <p>{{"login.unsubscribe" | translate}}</p>
    </div>
    <div *ngIf="!personalData?.subscribedForNewsLetter" class="news">
        <input (click)="subscribeForNewsLetter()" type="checkbox" />
        <p>{{"shoppingCart.newsLetter" | translate}}</p>
    </div>
    <div class="delete-button-container">
        <button (click)="deleteAccount(personalData?.email!)">Fiók törlése</button>
    </div>
    <div *ngIf="personalData!.isCompany" class="submit-button-container">
        <div class="submit-button">
            <button (click)="updateCompanyData()" [disabled]="!contactFormCompany?.valid" type="submit">Személyes adatok módosítása</button>
        </div>
    </div>
    <div *ngIf="!personalData!.isCompany" class="submit-button-container">
        <div class="submit-button">
            <button (click)="updateIndividualData()" [disabled]="!contactForm?.valid" type="submit">Személyes adatok módosítása</button>
        </div>
    </div>
</div>
